import { render, staticRenderFns } from "./upload-csv-view.vue?vue&type=template&id=2831a8cb&scoped=true"
import script from "./upload-csv-view.vue?vue&type=script&lang=js"
export * from "./upload-csv-view.vue?vue&type=script&lang=js"
import style0 from "./upload-csv-view.vue?vue&type=style&index=0&id=2831a8cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2831a8cb",
  null
  
)

export default component.exports